import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppContext } from "./AppContext";
import { Spinner } from "react-bootstrap";

const ProtectedRoute = () => {
  const { user, loading } = useAppContext();

  if (loading) {
    return <div className="loading-overlay"><Spinner animation="border" variant="info" role="status" /></div>;
  }

  if (user) {
    return <Outlet />;
  }

  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
